<template>
    <div class="polic-settings">
        <div class="preview-opration">
            <el-autocomplete placeholder="请输入交易对" style="width: 200px" v-model="pair" :fetch-suggestions="querySearchBrush"/>
            <el-button type="primary" style="margin-left: 10px" @click="searchData">搜索</el-button>
        </div>

        <Turnover :dataList="turnoverList" @refreshData="refreshData" :pair="pair"></Turnover>
        <RegularTrading :dataList="regularTradingList" @refreshData="refreshData" :pair="pair"></RegularTrading>
        <ReverserOrder :dataList="reverserOderList" @refreshData="refreshData" :pair="pair"></ReverserOrder>
        <RobotSpreadOrder :dataList="robotOderList" @refreshData="refreshData" :pair="pair"></RobotSpreadOrder>
        <ActiveOrder :dataList="activeList" @refreshData="refreshData" :pair="pair"></ActiveOrder>
    </div>
</template>

<script>
    import api from '../api';
    import Turnover from './turnover';
    import RegularTrading from './regularTrading';
    import ReverserOrder from './reverserOrder';
    import RobotSpreadOrder from './robotSpreadOrder';
    import ActiveOrder from './activeOrder';


    export default {
        name: "PolicSettings",
        components: {
            Turnover,
            ReverserOrder,
            RegularTrading,
            RobotSpreadOrder,
            ActiveOrder
        },
        data() {
            return {
                pair: "", //交易对
                turnoverList: [], //冰山策略
                regularTradingList: [], //定时操盘
                reverserOderList: [], //方向挂单
                robotOderList: [], //辅单机器人
                activeList: [], //盘面活跃
                allPair: [],
            };
        },
        created() {
            this.getAllPair();
        },
        methods: {
            getMachineStrategyAllConfig(pair) {
                api.getMachineStrategyAllConfig({pair: pair}).then(({data}) => {
                    this.clearData();
                    this.turnoverList = data.bingshanConf == null ? [] : [data.bingshanConf];
                    this.regularTradingList = data.stockOperateConf == null ? [] : [data.stockOperateConf];
                    this.reverserOderList = data.reverseOrder == null ? [] : [data.reverseOrder];
                    this.robotOderList = data.spreadOrderConfig == null ? [] : [data.spreadOrderConfig];
                    this.activeList = data.activeOrder == null ? [] : [data.activeOrder];
                });
            },
            searchData() {
                this.getMachineStrategyAllConfig(this.pair);
            },
            refreshData() {
                this.getMachineStrategyAllConfig(this.pair);
            },
            querySearchBrush(queryString,cb) {
                let restaurants = this.allPair;
                let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                let suggest = [];
                for(let index in results) {
                    suggest.push({'value':results[index]});
                }
                cb(suggest);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            getAllPair() {
                api.getAllPair().then(({data}) => {
                    this.allPair = data;
                });
            },
            clearData() {
                this.turnoverList = []; //冰山策略
                this.regularTradingList = []; //定时操盘
                this.reverserOderList = []; //方向挂单
                this.robotOderList = []; //辅单机器人
                this.activeList = []; //盘面活跃
            }
        }
    }
</script>

<style lang="less" scoped>
    .polic-settings {

    }
</style>